export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-[#1A3B5C] to-[#2A4B6C] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/569425149ee52b526abfe241b656c5c0.jpg"
          alt="Villa de luxe à Saly"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-8">
            <h1 className="text-5xl md:text-6xl font-extrabold leading-tight">
              La tranquillité de vos biens,{' '}
              <span className="relative inline-block">
                même à distance.
                <span className="absolute bottom-0 left-0 w-full h-1 bg-[#C9A961]"></span>
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl font-light text-white/90 tracking-wide">
              Gestion immobilière & conciergerie premium à Saly et sur la Petite Côte.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="https://wa.me/221XXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#1A3B5C] text-white px-8 py-4 rounded-lg hover:bg-[#2A4B6C] transition-all duration-300 flex items-center justify-center space-x-3 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                <span className="font-semibold text-lg">Contacter sur WhatsApp</span>
              </a>

              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="border-2 border-[#C9A961] text-white px-8 py-4 rounded-lg hover:bg-[#C9A961]/20 transition-all duration-300 font-semibold text-lg shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                Demander un audit gratuit
              </button>
            </div>

            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md px-6 py-3 rounded-full border border-white/20">
              <i className="ri-star-fill text-[#C9A961] text-xl"></i>
              <span className="text-white font-medium">Audit Gratuit Offert</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}